import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import useStore from '@/utils/store/common';
import Avatar from '@/components/common/Avatar/Avatar.vue';
import MasterComponent from '@/components/common/MasterComponent/MasterComponent.vue';
import About from './components/About/About.vue';
import HeaderLogo from './components/HeaderLogo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationHeader',
  setup(__props) {

const store = useStore();
const getCurrentUserName = computed(() => store.getters['user/getCurrentUserName']);

return { __sfc: true,store, getCurrentUserName, Avatar, MasterComponent, About, HeaderLogo }
}

})